module.exports = __webpack_public_path__ + "img/aiot_block5.3e0f8710.png";